<app-create-account-page
  [submitting]="creating$ | async"
  [error]="error$ | async"
  [userAccountNeedsValidation]="userAccountNeedsValidation"
  (onSubmit)="submitCreation($event)">
</app-create-account-page>
